/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { IcpmcpCore } from "../core.js";
import { SDKOptions } from "../lib/config.js";
import type { ConsoleLogger } from "./console-logger.js";
import { createRegisterPrompt } from "./prompts.js";
import {
  createRegisterResource,
  createRegisterResourceTemplate,
} from "./resources.js";
import { MCPScope } from "./scopes.js";
import { createRegisterTool } from "./tools.js";
import { tool$avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates } from "./tools/avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates.js";
import { tool$bitcoinGetApiV3BitcoinMainChainHeight } from "./tools/bitcoinGetApiV3BitcoinMainChainHeight.js";
import { tool$bitcoinGetApiV3BitcoinNumberOfUtxos } from "./tools/bitcoinGetApiV3BitcoinNumberOfUtxos.js";
import { tool$bitcoinGetApiV3BitcoinStableMemorySizeInBytes } from "./tools/bitcoinGetApiV3BitcoinStableMemorySizeInBytes.js";
import { tool$blockHeightsGetApiV3BlockHeights } from "./tools/blockHeightsGetApiV3BlockHeights.js";
import { tool$blockHeightsOverTimeGetApiV3BlockHeightsOverTime } from "./tools/blockHeightsOverTimeGetApiV3BlockHeightsOverTime.js";
import { tool$boundaryNodeLocationsGetApiV3BoundaryNodeLocations } from "./tools/boundaryNodeLocationsGetApiV3BoundaryNodeLocations.js";
import { tool$canistersGetApiV3Canisters } from "./tools/canistersGetApiV3Canisters.js";
import { tool$canistersGetApiV3CanistersCanisterId } from "./tools/canistersGetApiV3CanistersCanisterId.js";
import { tool$canistersGetApiV3CanistersCanisterIdName } from "./tools/canistersGetApiV3CanistersCanisterIdName.js";
import { tool$canistersGetApiV3CanistersNames } from "./tools/canistersGetApiV3CanistersNames.js";
import { tool$dailyStatsGetApiV3DailyStats } from "./tools/dailyStatsGetApiV3DailyStats.js";
import { tool$dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate } from "./tools/dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate.js";
import { tool$dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate } from "./tools/dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate.js";
import { tool$dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate } from "./tools/dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate.js";
import { tool$dataCentersGetApiV3DataCenters } from "./tools/dataCentersGetApiV3DataCenters.js";
import { tool$dataCentersGetApiV3DataCentersDcId } from "./tools/dataCentersGetApiV3DataCentersDcId.js";
import { tool$governanceMetricsGetApiV3GovernanceMetrics } from "./tools/governanceMetricsGetApiV3GovernanceMetrics.js";
import { tool$governanceMetricsGetApiV3GovernanceMetricsName } from "./tools/governanceMetricsGetApiV3GovernanceMetricsName.js";
import { tool$governanceMetricsGetApiV3StakingMetrics } from "./tools/governanceMetricsGetApiV3StakingMetrics.js";
import { tool$governanceMetricsGetApiV3StakingMetricsName } from "./tools/governanceMetricsGetApiV3StakingMetricsName.js";
import { tool$healthCheckGetApiV3HealthCheck } from "./tools/healthCheckGetApiV3HealthCheck.js";
import { tool$icpUsdRateGetApiV3IcpUsdPercentChange24h } from "./tools/icpUsdRateGetApiV3IcpUsdPercentChange24h.js";
import { tool$icpUsdRateGetApiV3IcpUsdRate } from "./tools/icpUsdRateGetApiV3IcpUsdRate.js";
import { tool$icpXdrConversionRatesGetApiV3IcpXdrConversionRates } from "./tools/icpXdrConversionRatesGetApiV3IcpXdrConversionRates.js";
import { tool$imagesGetApiV3ImagesAccountsAccountAddressPng } from "./tools/imagesGetApiV3ImagesAccountsAccountAddressPng.js";
import { tool$imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng } from "./tools/imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng.js";
import { tool$imagesGetApiV3ImagesCanistersCanisterIdPng } from "./tools/imagesGetApiV3ImagesCanistersCanisterIdPng.js";
import { tool$imagesGetApiV3ImagesDataCentersDcIdPng } from "./tools/imagesGetApiV3ImagesDataCentersDcIdPng.js";
import { tool$imagesGetApiV3ImagesNeuronsNeuronIdPng } from "./tools/imagesGetApiV3ImagesNeuronsNeuronIdPng.js";
import { tool$imagesGetApiV3ImagesNodeProvidersNodeProviderIdPng } from "./tools/imagesGetApiV3ImagesNodeProvidersNodeProviderIdPng.js";
import { tool$imagesGetApiV3ImagesNodesNodeIdPng } from "./tools/imagesGetApiV3ImagesNodesNodeIdPng.js";
import { tool$imagesGetApiV3ImagesProposalsProposalIdPng } from "./tools/imagesGetApiV3ImagesProposalsProposalIdPng.js";
import { tool$imagesGetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPng } from "./tools/imagesGetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPng.js";
import { tool$imagesGetApiV3ImagesSubnetsSubnetIdPng } from "./tools/imagesGetApiV3ImagesSubnetsSubnetIdPng.js";
import { tool$imagesGetApiV3ImagesTransactionsTransactionHashPng } from "./tools/imagesGetApiV3ImagesTransactionsTransactionHashPng.js";
import { tool$messagesCountsGetApiV3MessagesCounts } from "./tools/messagesCountsGetApiV3MessagesCounts.js";
import { tool$messagesCountsOverTimeGetApiV3MessagesCountsOverTime } from "./tools/messagesCountsOverTimeGetApiV3MessagesCountsOverTime.js";
import { tool$metricsGetApiV3MetricsAverageCycleBurnRate } from "./tools/metricsGetApiV3MetricsAverageCycleBurnRate.js";
import { tool$metricsGetApiV3MetricsAverageGovernanceVotingPowerTotal } from "./tools/metricsGetApiV3MetricsAverageGovernanceVotingPowerTotal.js";
import { tool$metricsGetApiV3MetricsAverageLastRewardEvent } from "./tools/metricsGetApiV3MetricsAverageLastRewardEvent.js";
import { tool$metricsGetApiV3MetricsBlockCount } from "./tools/metricsGetApiV3MetricsBlockCount.js";
import { tool$metricsGetApiV3MetricsBlockHeight } from "./tools/metricsGetApiV3MetricsBlockHeight.js";
import { tool$metricsGetApiV3MetricsBlockRate } from "./tools/metricsGetApiV3MetricsBlockRate.js";
import { tool$metricsGetApiV3MetricsBoundaryNodesCount } from "./tools/metricsGetApiV3MetricsBoundaryNodesCount.js";
import { tool$metricsGetApiV3MetricsCommunityFundTotalMaturity } from "./tools/metricsGetApiV3MetricsCommunityFundTotalMaturity.js";
import { tool$metricsGetApiV3MetricsCommunityFundTotalStaked } from "./tools/metricsGetApiV3MetricsCommunityFundTotalStaked.js";
import { tool$metricsGetApiV3MetricsCycleBurnRate } from "./tools/metricsGetApiV3MetricsCycleBurnRate.js";
import { tool$metricsGetApiV3MetricsEgressBandwidth } from "./tools/metricsGetApiV3MetricsEgressBandwidth.js";
import { tool$metricsGetApiV3MetricsEnergyConsumptionRate } from "./tools/metricsGetApiV3MetricsEnergyConsumptionRate.js";
import { tool$metricsGetApiV3MetricsEthEquivalentTxns } from "./tools/metricsGetApiV3MetricsEthEquivalentTxns.js";
import { tool$metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year } from "./tools/metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year.js";
import {
  tool$metricsGetApiV3MetricsGovernanceDissolvingNeuronsStakedMaturityE8sEquivalent1year,
} from "./tools/metricsGetApiV3MetricsGovernanceDissolvingNeuronsStakedMaturityE8sEquivalent1year.js";
import { tool$metricsGetApiV3MetricsGovernanceNeuronsTotal } from "./tools/metricsGetApiV3MetricsGovernanceNeuronsTotal.js";
import { tool$metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsE8s1year } from "./tools/metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsE8s1year.js";
import {
  tool$metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year,
} from "./tools/metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year.js";
import { tool$metricsGetApiV3MetricsGovernanceVotingPowerTotal } from "./tools/metricsGetApiV3MetricsGovernanceVotingPowerTotal.js";
import { tool$metricsGetApiV3MetricsIcCpuCores } from "./tools/metricsGetApiV3MetricsIcCpuCores.js";
import { tool$metricsGetApiV3MetricsIcMemoryTotal } from "./tools/metricsGetApiV3MetricsIcMemoryTotal.js";
import { tool$metricsGetApiV3MetricsIcMemoryUsage } from "./tools/metricsGetApiV3MetricsIcMemoryUsage.js";
import { tool$metricsGetApiV3MetricsIcNodesCount } from "./tools/metricsGetApiV3MetricsIcNodesCount.js";
import { tool$metricsGetApiV3MetricsIcpTxnVsEthTxn } from "./tools/metricsGetApiV3MetricsIcpTxnVsEthTxn.js";
import { tool$metricsGetApiV3MetricsIcSubnetTotal } from "./tools/metricsGetApiV3MetricsIcSubnetTotal.js";
import { tool$metricsGetApiV3MetricsIngressBandwidth } from "./tools/metricsGetApiV3MetricsIngressBandwidth.js";
import { tool$metricsGetApiV3MetricsInstructionRate } from "./tools/metricsGetApiV3MetricsInstructionRate.js";
import { tool$metricsGetApiV3MetricsInternetIdentityUserCount } from "./tools/metricsGetApiV3MetricsInternetIdentityUserCount.js";
import { tool$metricsGetApiV3MetricsLastRewardEvent } from "./tools/metricsGetApiV3MetricsLastRewardEvent.js";
import { tool$metricsGetApiV3MetricsLatestRewardEventTotalAvailable } from "./tools/metricsGetApiV3MetricsLatestRewardEventTotalAvailable.js";
import { tool$metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days } from "./tools/metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days.js";
import { tool$metricsGetApiV3MetricsMemory } from "./tools/metricsGetApiV3MetricsMemory.js";
import { tool$metricsGetApiV3MetricsMessageExecutionRate } from "./tools/metricsGetApiV3MetricsMessageExecutionRate.js";
import { tool$metricsGetApiV3MetricsNodeEnergyConsumptionRateKwh } from "./tools/metricsGetApiV3MetricsNodeEnergyConsumptionRateKwh.js";
import { tool$metricsGetApiV3MetricsRegisteredCanistersCount } from "./tools/metricsGetApiV3MetricsRegisteredCanistersCount.js";
import { tool$metricsGetApiV3MetricsTotalActiveNodesCount } from "./tools/metricsGetApiV3MetricsTotalActiveNodesCount.js";
import { tool$metricsGetApiV3MetricsTotalAwaitingNodesCount } from "./tools/metricsGetApiV3MetricsTotalAwaitingNodesCount.js";
import { tool$metricsGetApiV3MetricsTotalIcEnergyConsumptionRateKwh } from "./tools/metricsGetApiV3MetricsTotalIcEnergyConsumptionRateKwh.js";
import { tool$metricsGetApiV3MetricsTotalOfflineNodesCount } from "./tools/metricsGetApiV3MetricsTotalOfflineNodesCount.js";
import { tool$metricsGetApiV3MetricsTotalRewardableNodesCount } from "./tools/metricsGetApiV3MetricsTotalRewardableNodesCount.js";
import { tool$metricsGetApiV3MetricsTransactionRate } from "./tools/metricsGetApiV3MetricsTransactionRate.js";
import { tool$networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter } from "./tools/networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter.js";
import { tool$neuronMaturityModulationsGetApiV3NeuronMaturityModulations } from "./tools/neuronMaturityModulationsGetApiV3NeuronMaturityModulations.js";
import { tool$neuronsGetApiV3KnownNeuronsNeuronIdBallots } from "./tools/neuronsGetApiV3KnownNeuronsNeuronIdBallots.js";
import { tool$neuronsGetApiV3Neurons } from "./tools/neuronsGetApiV3Neurons.js";
import { tool$neuronsGetApiV3NeuronsNeuronId } from "./tools/neuronsGetApiV3NeuronsNeuronId.js";
import { tool$neuronsGetApiV3NeuronsNeuronIdBallots } from "./tools/neuronsGetApiV3NeuronsNeuronIdBallots.js";
import { tool$neuronsGetApiV3NeuronsNeuronIdRecentBallots } from "./tools/neuronsGetApiV3NeuronsNeuronIdRecentBallots.js";
import { tool$neuronVotingPowersGetApiV3NeuronVotingPowers } from "./tools/neuronVotingPowersGetApiV3NeuronVotingPowers.js";
import { tool$nodeProvidersGetApiV3NodeProviders } from "./tools/nodeProvidersGetApiV3NodeProviders.js";
import { tool$nodeProvidersGetApiV3NodeProvidersCount } from "./tools/nodeProvidersGetApiV3NodeProvidersCount.js";
import { tool$nodeProvidersGetApiV3NodeProvidersNodeProviderId } from "./tools/nodeProvidersGetApiV3NodeProvidersNodeProviderId.js";
import { tool$nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes } from "./tools/nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes.js";
import { tool$nodesGetApiV3Nodes } from "./tools/nodesGetApiV3Nodes.js";
import { tool$nodesGetApiV3NodesNodeId } from "./tools/nodesGetApiV3NodesNodeId.js";
import { tool$participationRatesGetApiV3ParticipationRates } from "./tools/participationRatesGetApiV3ParticipationRates.js";
import { tool$proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions } from "./tools/proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions.js";
import { tool$proposalsGetApiV3LatestProposalId } from "./tools/proposalsGetApiV3LatestProposalId.js";
import { tool$proposalsGetApiV3MetricsLatestProposalId } from "./tools/proposalsGetApiV3MetricsLatestProposalId.js";
import { tool$proposalsGetApiV3NnsParticipationRate } from "./tools/proposalsGetApiV3NnsParticipationRate.js";
import { tool$proposalsGetApiV3Proposals } from "./tools/proposalsGetApiV3Proposals.js";
import { tool$proposalsGetApiV3ProposalsCount } from "./tools/proposalsGetApiV3ProposalsCount.js";
import { tool$proposalsGetApiV3ProposalsOverPast7d } from "./tools/proposalsGetApiV3ProposalsOverPast7d.js";
import { tool$proposalsGetApiV3ProposalsProposalId } from "./tools/proposalsGetApiV3ProposalsProposalId.js";
import { tool$proposalsOverTimeGetApiV3ProposalsOverTime } from "./tools/proposalsOverTimeGetApiV3ProposalsOverTime.js";
import { tool$proposalTalliesGetApiV3ProposalsProposalIdTallies } from "./tools/proposalTalliesGetApiV3ProposalsProposalIdTallies.js";
import { tool$rewardNodeProvidersGetApiV3RewardNodeProviders } from "./tools/rewardNodeProvidersGetApiV3RewardNodeProviders.js";
import { tool$rewardNodeProvidersGetApiV3RewardNodeProvidersId } from "./tools/rewardNodeProvidersGetApiV3RewardNodeProvidersId.js";
import { tool$rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders } from "./tools/rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders.js";
import { tool$rootGetApiV3 } from "./tools/rootGetApiV3.js";
import { tool$rootGetApiV3Changelog } from "./tools/rootGetApiV3Changelog.js";
import { tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersions } from "./tools/subnetReplicaVersionsGetApiV3SubnetReplicaVersions.js";
import { tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId } from "./tools/subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId.js";
import { tool$subnetsGetApiV3Subnets } from "./tools/subnetsGetApiV3Subnets.js";
import { tool$subnetsGetApiV3SubnetsSubnetId } from "./tools/subnetsGetApiV3SubnetsSubnetId.js";
import { tool$v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters } from "./tools/v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters.js";
import { tool$v4NeuronVotingPowersGetApiV4NeuronVotingPowers } from "./tools/v4NeuronVotingPowersGetApiV4NeuronVotingPowers.js";
import { tool$v4SubnetsGetApiV4Subnets } from "./tools/v4SubnetsGetApiV4Subnets.js";
import { tool$v4SubnetsGetApiV4SubnetsCount } from "./tools/v4SubnetsGetApiV4SubnetsCount.js";
import { tool$v4SubnetsGetApiV4SubnetsSubnetId } from "./tools/v4SubnetsGetApiV4SubnetsSubnetId.js";

export function createMCPServer(deps: {
  logger: ConsoleLogger;
  allowedTools?: string[] | undefined;
  scopes?: MCPScope[] | undefined;
  serverURL: string;
  serverIdx?: SDKOptions["serverIdx"] | undefined;
}) {
  const server = new McpServer({
    name: "Icpmcp",
    version: "0.0.1",
  });

  const client = new IcpmcpCore({
    serverURL: deps.serverURL,
    serverIdx: deps.serverIdx,
  });

  const scopes = new Set(deps.scopes);

  const allowedTools = deps.allowedTools && new Set(deps.allowedTools);
  const tool = createRegisterTool(
    deps.logger,
    server,
    client,
    scopes,
    allowedTools,
  );
  const resource = createRegisterResource(deps.logger, server, client, scopes);
  const resourceTemplate = createRegisterResourceTemplate(
    deps.logger,
    server,
    client,
    scopes,
  );
  const prompt = createRegisterPrompt(deps.logger, server, client, scopes);
  const register = { tool, resource, resourceTemplate, prompt };
  void register; // suppress unused warnings

  tool(tool$avgIcpXdrConversionRatesGetApiV3AvgIcpXdrConversionRates);
  tool(tool$bitcoinGetApiV3BitcoinMainChainHeight);
  tool(tool$bitcoinGetApiV3BitcoinNumberOfUtxos);
  tool(tool$bitcoinGetApiV3BitcoinStableMemorySizeInBytes);
  tool(tool$blockHeightsGetApiV3BlockHeights);
  tool(tool$blockHeightsOverTimeGetApiV3BlockHeightsOverTime);
  tool(tool$boundaryNodeLocationsGetApiV3BoundaryNodeLocations);
  tool(tool$canistersGetApiV3Canisters);
  tool(tool$canistersGetApiV3CanistersCanisterId);
  tool(tool$canistersGetApiV3CanistersCanisterIdName);
  tool(tool$canistersGetApiV3CanistersNames);
  tool(tool$dataCentersGetApiV3DataCenters);
  tool(tool$dataCentersGetApiV3DataCentersDcId);
  tool(tool$dailyStatsGetApiV3DailyStats);
  tool(tool$dailyStatsGetApiV3DailyStatsMaxTotalTransactionsPerSecTillDate);
  tool(tool$dailyStatsGetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDate);
  tool(tool$dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate);
  tool(tool$governanceMetricsGetApiV3GovernanceMetrics);
  tool(tool$governanceMetricsGetApiV3StakingMetrics);
  tool(tool$governanceMetricsGetApiV3GovernanceMetricsName);
  tool(tool$governanceMetricsGetApiV3StakingMetricsName);
  tool(tool$healthCheckGetApiV3HealthCheck);
  tool(tool$icpUsdRateGetApiV3IcpUsdRate);
  tool(tool$icpUsdRateGetApiV3IcpUsdPercentChange24h);
  tool(tool$icpXdrConversionRatesGetApiV3IcpXdrConversionRates);
  tool(tool$imagesGetApiV3ImagesProposalsProposalIdPng);
  tool(tool$imagesGetApiV3ImagesCanistersCanisterIdPng);
  tool(tool$imagesGetApiV3ImagesDataCentersDcIdPng);
  tool(tool$imagesGetApiV3ImagesNeuronsNeuronIdPng);
  tool(tool$imagesGetApiV3ImagesNodesNodeIdPng);
  tool(tool$imagesGetApiV3ImagesNodeProvidersNodeProviderIdPng);
  tool(tool$imagesGetApiV3ImagesSubnetReplicaVersionsReplicaVersionIdPng);
  tool(tool$imagesGetApiV3ImagesSubnetsSubnetIdPng);
  tool(tool$imagesGetApiV3ImagesAccountsAccountAddressPng);
  tool(tool$imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng);
  tool(tool$imagesGetApiV3ImagesTransactionsTransactionHashPng);
  tool(tool$metricsGetApiV3MetricsMessageExecutionRate);
  tool(tool$metricsGetApiV3MetricsIcNodesCount);
  tool(tool$metricsGetApiV3MetricsIcMemoryTotal);
  tool(tool$metricsGetApiV3MetricsIcCpuCores);
  tool(tool$metricsGetApiV3MetricsIcMemoryUsage);
  tool(tool$metricsGetApiV3MetricsMemory);
  tool(tool$metricsGetApiV3MetricsBlockRate);
  tool(tool$metricsGetApiV3MetricsBlockCount);
  tool(tool$metricsGetApiV3MetricsEgressBandwidth);
  tool(tool$metricsGetApiV3MetricsIngressBandwidth);
  tool(tool$metricsGetApiV3MetricsBoundaryNodesCount);
  tool(tool$metricsGetApiV3MetricsGovernanceNeuronsTotal);
  tool(tool$metricsGetApiV3MetricsInternetIdentityUserCount);
  tool(tool$metricsGetApiV3MetricsGovernanceVotingPowerTotal);
  tool(tool$metricsGetApiV3MetricsAverageGovernanceVotingPowerTotal);
  tool(tool$metricsGetApiV3MetricsCycleBurnRate);
  tool(tool$metricsGetApiV3MetricsIcSubnetTotal);
  tool(tool$metricsGetApiV3MetricsLastRewardEvent);
  tool(tool$metricsGetApiV3MetricsLatestRewardEventTotalAvailable);
  tool(tool$metricsGetApiV3MetricsAverageLastRewardEvent);
  tool(tool$metricsGetApiV3MetricsCommunityFundTotalStaked);
  tool(tool$metricsGetApiV3MetricsCommunityFundTotalMaturity);
  tool(tool$metricsGetApiV3MetricsTotalRewardableNodesCount);
  tool(tool$metricsGetApiV3MetricsRegisteredCanistersCount);
  tool(tool$metricsGetApiV3MetricsBlockHeight);
  tool(tool$metricsGetApiV3MetricsTotalActiveNodesCount);
  tool(tool$metricsGetApiV3MetricsTotalAwaitingNodesCount);
  tool(tool$metricsGetApiV3MetricsTotalOfflineNodesCount);
  tool(tool$metricsGetApiV3MetricsEnergyConsumptionRate);
  tool(tool$metricsGetApiV3MetricsTotalIcEnergyConsumptionRateKwh);
  tool(tool$metricsGetApiV3MetricsNodeEnergyConsumptionRateKwh);
  tool(tool$metricsGetApiV3MetricsTransactionRate);
  tool(tool$metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days);
  tool(tool$metricsGetApiV3MetricsInstructionRate);
  tool(tool$metricsGetApiV3MetricsAverageCycleBurnRate);
  tool(tool$metricsGetApiV3MetricsIcpTxnVsEthTxn);
  tool(tool$metricsGetApiV3MetricsEthEquivalentTxns);
  tool(tool$metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsE8s1year);
  tool(tool$metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year);
  tool(
    tool$metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year,
  );
  tool(
    tool$metricsGetApiV3MetricsGovernanceDissolvingNeuronsStakedMaturityE8sEquivalent1year,
  );
  tool(tool$messagesCountsGetApiV3MessagesCounts);
  tool(tool$messagesCountsOverTimeGetApiV3MessagesCountsOverTime);
  tool(
    tool$networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter,
  );
  tool(tool$neuronsGetApiV3Neurons);
  tool(tool$neuronsGetApiV3NeuronsNeuronId);
  tool(tool$neuronsGetApiV3NeuronsNeuronIdRecentBallots);
  tool(tool$neuronsGetApiV3KnownNeuronsNeuronIdBallots);
  tool(tool$neuronsGetApiV3NeuronsNeuronIdBallots);
  tool(tool$neuronMaturityModulationsGetApiV3NeuronMaturityModulations);
  tool(tool$neuronVotingPowersGetApiV3NeuronVotingPowers);
  tool(tool$nodesGetApiV3Nodes);
  tool(tool$nodesGetApiV3NodesNodeId);
  tool(tool$nodeProvidersGetApiV3NodeProviders);
  tool(tool$nodeProvidersGetApiV3NodeProvidersNodeProviderId);
  tool(tool$nodeProvidersGetApiV3NodeProvidersNodeProviderIdNodes);
  tool(tool$nodeProvidersGetApiV3NodeProvidersCount);
  tool(tool$participationRatesGetApiV3ParticipationRates);
  tool(tool$proposalsGetApiV3Proposals);
  tool(tool$proposalsGetApiV3NnsParticipationRate);
  tool(tool$proposalsGetApiV3ProposalsProposalId);
  tool(tool$proposalsGetApiV3ProposalsCount);
  tool(tool$proposalsGetApiV3LatestProposalId);
  tool(tool$proposalsGetApiV3MetricsLatestProposalId);
  tool(tool$proposalsGetApiV3ProposalsOverPast7d);
  tool(tool$proposalsOverTimeGetApiV3ProposalsOverTime);
  tool(tool$proposalTalliesGetApiV3ProposalsProposalIdTallies);
  tool(
    tool$proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions,
  );
  tool(tool$rewardNodeProvidersGetApiV3TimeseriesRewardNodeProviders);
  tool(tool$rewardNodeProvidersGetApiV3RewardNodeProviders);
  tool(tool$rewardNodeProvidersGetApiV3RewardNodeProvidersId);
  tool(tool$rootGetApiV3);
  tool(tool$rootGetApiV3Changelog);
  tool(tool$subnetsGetApiV3Subnets);
  tool(tool$subnetsGetApiV3SubnetsSubnetId);
  tool(tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersions);
  tool(tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId);
  tool(tool$v4BoundaryNodeDataCentersGetApiV4BoundaryNodeDataCenters);
  tool(tool$v4NeuronVotingPowersGetApiV4NeuronVotingPowers);
  tool(tool$v4SubnetsGetApiV4Subnets);
  tool(tool$v4SubnetsGetApiV4SubnetsSubnetId);
  tool(tool$v4SubnetsGetApiV4SubnetsCount);

  return server;
}
